import * as Scrivito from "scrivito";
import { TabItemWidget } from "./TabItemWidgetClass";

Scrivito.provideEditingConfig("TabWidget", {
  title: "Tab Widget",
  properties: ["style", "tabs", "asHeadline"],
  initialContent: {
    tabs: [
      new TabItemWidget({ headline: "Tab 1" }),
      new TabItemWidget({ headline: "Tab 2" }),
      new TabItemWidget({ headline: "Tab 3" }),
    ],
    style: "default-style",
  },
});
